export default __webpack_public_path__ + "ac11c26e1325ce8abbf4901a758455d2.svg";